import styled from "styled-components";
import { Flex, Text } from "rebass";

export const Banner = styled(Flex)`
  background-color: #608341;
  width: 100%;
`;

export const Headline = styled(Text)`
  color: white;
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif;
  text-align: center;  
`;
